<template>
        <el-form ref="form" :model="form" label-width="200px" :rules="rules" class="demo-ruleForm" >

            <el-form-item label="邮箱账号:" prop="zhanghao"  >
                <el-input v-model="form.zhanghao" placeholder="邮箱账号" ></el-input>
            </el-form-item>

            <el-form-item label="POP3/SMTP服务授权码:" prop="shouquanma" >
                <el-input v-model="form.shouquanma" placeholder="POP3/SMTP服务授权码" ></el-input>
            </el-form-item>

            <el-form-item label="SMTP服务器:" prop="fuwuqi" >
                <el-input v-model="form.fuwuqi" placeholder="SMTP服务器" :validate-event="false"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary"  @click="submitForm('form')">保存</el-button>
                <el-button @click="resetForm('form')">重置</el-button>
            </el-form-item>

        </el-form>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    zhanghao: '',
                    shouquanma: '',
                    fuwuqi: ''
                },
                rules:{
                    zhanghao:[
                        { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                        ],
                    shouquanma:[
                          { required: true, message: '授权码不为空', trigger: 'blur' }],
                    fuwuqi:[
                        { required: true, message: '不能为空', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            submitForm(form) {
                console.log(this.form);
                this.$refs[form].validate((valid) => {
                    this.$refs[form].validate((valid) => {
                        if (valid) {
                            this.$api.request(this.$url.Email.save,this.$method.post,this.form).then(res => {
                                if (res.code === 0) {
                                    this.$notify({
                                        title: '保存成功',
                                        message: res.msg,
                                        type: 'success'
                                    });
                                }
                            }).catch((err) => {
                                this.$notify({
                                    title: '保存失败',
                                    message: err.msg,
                                    type: 'error'
                                });
                            })
                        }
                    })
                })
            },
            resetForm(form){
                this.$refs[form].resetFields();
            }
            }
    };
</script>

<style scoped lang="scss">
    .el-input{
        width: 40%;
    }
    .el-form{
        form{
            width:90%;
            margin: auto;
            border:.01rem solid gray;
            display: flex;
            flex-wrap: wrap;
            input{
                width:80%;
                height:.5rem;
                margin-bottom: .2rem;
                border:.01rem solid black;
                height:.5rem;
            }
        }
        .but{
            font-size: .14rem;
            margin-left:5%;
        }

    }
</style>